import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProfessionalRegistration from "./pages/ProfessionalRegistration";
import Login from "./pages/Login";
import PanelAdmin from "./pages/PanelAdmin";
import TableProfessional from "./components/PanelAdmin/TableProfessional";
import TableEmpresa from "./components/PanelAdmin/TableEmpresa";
import ResumenAdmin from "./components/PanelAdmin/ResumenAdmin";
import TableUser from "./components/PanelAdmin/TableUser";

import Test from "./pages/Test";
import DetailsProfessional from "./pages/DetailsProfessional";
import RegisterUser from "./pages/RegisterUser";
import PanelProfessional from "./pages/PanelProfessional";
import TableShift from "./pages/TableShift";
import TableAcceptedShifts from "./components/PanelProfessional/TableAcceptedShifts";
import PerfilProfessional from "./components/PanelProfessional/PerfilProfessional";
import ResumenProfesional from "./components/PanelProfessional/ResumenProfesional";

import RegisterSede from "./pages/RegisterSede";
import TableSede from "./components/PanelAdmin/TableSede";
import Configuracion from "./components/PanelAdmin/Configuracion";
import PanelSede from "./pages/PanelSede";
import TableInPersonShifts from "./components/PanelSede/TableInPersonShifts";
import PerfilSede from "./components/PanelSede/PerfilSede";
import ResumenSede from "./components/PanelSede/ResumenSede";

import PanelEmpresa from "./pages/PanelEmpresa";
import TableSedesEmpresa from "./components/PanelEmpresa/TableSedesEmpresa";
import TableProfesionalesEmpresa from "./components/PanelEmpresa/TableProfesionalesEmpresa";
import PerfilEmpresa from "./components/PanelEmpresa/PerfilEmpresa";
import ResumenEmpresa from "./components/PanelEmpresa/ResumenEmpresa";

import MessageSuccess from "./pages/MessageSuccess";
import RegisterSedesSuccess from "./pages/RegisterSedesSuccess";
import RegisterProfessionalSuccess from "./pages/RegisterProfessionalSuccess";
import TermsAndConditions from "./pages/TermsAndConditions";
import RegisterEmpresa from "./pages/RegisterEmpresa";
import RegisterBisnessSuccess from "./pages/RegisterBisnessSuccess";
import RegisterUserSuccess from "./pages/RegisterUserSuccess";
import DetailsUser from "./pages/DetailsUser";
import HistorialUser from "./pages/HistorialUser";
import MisCitas from "./pages/MisCitas";
import HistorialMedico from "./pages/HistorialMedico";
import MisRecetas from "./pages/MisRecetas";
import Dependientes from "./pages/Dependientes";
import LibroReclamaciones from "./pages/LibroReclamaciones";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          <Route path="/registrar-profesional" element={<ProfessionalRegistration />} />
          <Route path="/registrar-usuario" element={<RegisterUser />} />
          <Route path="/registrar-sede" element={<RegisterSede />} />
          <Route path="/registrar-empresa" element={<RegisterEmpresa />} />

          <Route path="/mi-perfil/profesional" element={<DetailsProfessional />} />
          <Route path="/mi-perfil" element={<DetailsUser />} />

          <Route path="/reservación-exitosa" element={<MessageSuccess />} />
          <Route path="/registro/sede-exitosa" element={<RegisterSedesSuccess />} />
          <Route path="/registro/profesional-exitosa" element={<RegisterProfessionalSuccess />} />
          <Route path="/registrado-exitosamente" element={<RegisterUserSuccess />} />
          <Route path="/formulario-enviado" element={<RegisterBisnessSuccess />} />

          <Route path="/terminos-condiciones" element={<TermsAndConditions />} />
          <Route path="/mis-consultas" element={<HistorialUser />} />
          <Route path="/mis-citas" element={<MisCitas />} />
          <Route path="/historial-medico" element={<HistorialMedico />} />
          <Route path="/mis-recetas" element={<MisRecetas />} />
          <Route path="/dependientes" element={<Dependientes />} />
          <Route path="/libro-de-quejas" element={<LibroReclamaciones />} />

          <Route path="/test" element={<Test />} />

          <Route path="/administrar" element={<PanelAdmin />}>
            <Route index element={<ResumenAdmin />} />
            <Route path="profesionales" element={<TableProfessional />} />
            <Route path="sedes" element={<TableSede />} />
            <Route path="empresas" element={<TableEmpresa />} />
            <Route path="usuarios" element={<TableUser />} />
            <Route path="configuracion" element={<Configuracion />} />
          </Route>

          <Route path="/panel" element={<PanelProfessional />}>
            <Route index element={<ResumenProfesional />} />
            <Route path="consultas/disponibles" element={<TableShift />} />
            <Route path="consultas/aceptadas" element={<TableAcceptedShifts />} />
            <Route path="perfil" element={<PerfilProfessional />} />
          </Route>

          <Route path="/panel/sede" element={<PanelSede />}>
            <Route index element={<ResumenSede />} />
            <Route path="turnos" element={<TableInPersonShifts />} />
            <Route path="perfil" element={<PerfilSede />} />
          </Route>

          <Route path="/panel/empresa" element={<PanelEmpresa />}>
            <Route index element={<ResumenEmpresa />} />
            <Route path="sedes" element={<TableSedesEmpresa />} />
            <Route path="profesionales" element={<TableProfesionalesEmpresa />} />
            <Route path="perfil" element={<PerfilEmpresa />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
